(() => {
  if (customElements.get('cgt-pack-choices')) return;
  class CgtPackChoices extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info') || this.closest('.product__info-container') || this.closest('section');
      this.input = this.scope?.querySelector('input[name="quantity"]');
      this.buttons = [...this.querySelectorAll('[data-count]')];
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.price = Number(this.dataset.price);
      this.choice = Number(this.input?.value || 1);
      this.clickHandler = event => {
        const button = event.target.closest('[data-count]');
        if (button && !button.disabled && this.contains(button)) this.setQuantity(Number(button.dataset.count));
      };
      this.changeHandler = event => {
        if (event.target === this.input) this.choice = Number(this.input.value);
        this.refresh();
      };
      this.addEventListener('click', this.clickHandler);
      this.scope?.addEventListener('change', this.changeHandler);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (event.data.sectionId !== this.dataset.section) return;
          const variant = event.data.variant;
          if (!variant) return;
          this.price = variant.price;
          this.available = variant.available;
          queueMicrotask(() => this.setQuantity(this.choice));
        });
        this.quantityUnsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
          this.refresh();
        });
      }
      this.refresh();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.clickHandler);
      this.scope?.removeEventListener('change', this.changeHandler);
      this.unsubscribe?.();
      this.quantityUnsubscribe?.();
    }
    setQuantity(count) {
      if (!this.input) return;
      const min = Number(this.input.min || 1);
      const max = this.input.max ? Number(this.input.max) : Infinity;
      const step = Number(this.input.step || 1);
      const bounded = Math.min(max, Math.max(min, count));
      this.input.value = String(min + Math.floor((bounded - min) / step) * step);
      this.choice = Number(this.input.value);
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.refresh();
    }
    refresh() {
      const id = this.scope?.querySelector('input.product-variant-id, form input[name="id"]')?.value;
      const variant = this.variants.find(v => String(v.id) === String(id || this.dataset.variant));
      if (variant) { this.price = variant.price; this.available = variant.available; }
      const formatter = new Intl.NumberFormat('en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      for (const button of this.buttons) {
        const count = Number(button.dataset.count);
        const min = Number(this.input?.min || 1);
        const max = this.input?.max ? Number(this.input.max) : Infinity;
        const step = Number(this.input?.step || 1);
        button.disabled = !this.input || this.available === false || count < min || count > max || (count - min) % step !== 0;
        button.setAttribute('aria-pressed', String(count === Number(this.input?.value)));
        const regular = this.price * count;
        const discount = count >= 2 ? Math.round(regular * Number(this.dataset.discount || 0) / 100) : 0;
        const money = cents => formatter.format(cents / 100) + ' ' + (this.dataset.currency || 'USD');
        button.querySelector('[data-total]').textContent = money(regular - discount);
        const compare = button.querySelector('[data-compare]');
        const saving = button.querySelector('[data-saving]');
        if (compare) compare.textContent = money(regular);
        if (saving) saving.textContent = money(discount);
      }
    }
  }
  customElements.define('cgt-pack-choices', CgtPackChoices);
})();